import { CircularProgress, Stack, Typography } from "@mui/material";
import { ChartText, ChartWrapper, InspectBtn, ItemWrapper } from "./styles";
import { Doughnut } from "react-chartjs-2";

export const CheckItem = ({ label, loading, score, description, onClick, onInspect }) => {
  const remaining = 100 - score;

  const data = {
    labels: [],
    datasets: [
      {
        label: [],
        data: [score, remaining],
        backgroundColor: ["#F7CF51", "#F4DFB5"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    cutout: "64%",
    plugins: {
      legend: { display: false },
    },
  };

  return (
    <ItemWrapper onClick={onClick}>
      {loading ? (
        <Stack alignItems="center" justifyContent="center" width="200px" height="200px">
          <CircularProgress color="primary" />
        </Stack>
      ) : (
        <ChartWrapper>
          <Doughnut data={data} options={options} />
          <ChartText variant="h3">{score}%</ChartText>
        </ChartWrapper>
      )}

      <Typography variant="h4">{label}</Typography>
      <Typography variant="body1">{description}</Typography>
      <InspectBtn variant="contained" onClick={onInspect} disabled={loading}>
        Inspect
      </InspectBtn>
    </ItemWrapper>
  );
};
